import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseAutocompleteModule } from '../base-autocomplete/base-autocomplete.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class AutocompleteInPlaceModule {
}
AutocompleteInPlaceModule.ɵfac = function AutocompleteInPlaceModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutocompleteInPlaceModule)(); };
AutocompleteInPlaceModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AutocompleteInPlaceModule });
AutocompleteInPlaceModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule,
        BaseAutocompleteModule,
        CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        MetricSelectorModalModule,
        TooltipModule] });
